import { FC, useEffect, useState, useContext } from "react";
import KickImage from 'Reuseables/KickImage';
import Component from "./Component";

//Actions
import { getOrderDetails, getReceipt } from "../../../../actions/shipperAction";

//Context
import ShipperContext from "../context";

//Helper
import { formatCurrency } from "../../../../utils/Helpers";

//Interface
import { OrderDetailsInterface } from "../definitions";

type Props = {
  onBack: (args?: string) => void;
  seeNote: (args?: string) => void;
  order_id: string | undefined;
}

const PickupDetails: FC<Props> = ({
  onBack,
  seeNote,
  order_id
}) => {
  const { ratio, currency } = useContext(ShipperContext);

  const [loading, setLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState<OrderDetailsInterface | null>(null);

  const currencyHandler = (val) => formatCurrency(val, ratio, currency);

  const getOrderDetailsHandler = async (order_id) => {
    try {
      setLoading(true)
      await getOrderDetails(order_id)
        .then(res => res?.data)
        .then(res => {
          if(!res.data) return;

          let _orderDetail = {...res.data}

          if(!_orderDetail.time_slot_selected?.start_time) {
            let _timeslot = localStorage.getItem(`${order_id}_TIMESLOT`)
            _timeslot && (_timeslot = JSON.parse(_timeslot))

            _orderDetail = {..._orderDetail, time_slot_selected: _timeslot}
          } else {
            localStorage.removeItem(`${order_id}_TIMESLOT`)
          }

          setOrderDetails(_orderDetail)
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })

    } catch (err) {
      setLoading(false)
      console.log(err, "Err when fetching order details, PickupDetails.tsx")
    }
  }

  const downloadHandler = async () => {
    await getReceipt(order_id)
      .then(res => res.data)
      .then(res => { window.open(res?.data, "_blank") })
  }

useEffect(() => {
  getOrderDetailsHandler(order_id)
}, [])

return (
  <Component
    loading={loading}
    orderDetails={orderDetails}
    downloadHandler={downloadHandler}
    onBack={onBack}
    seeNote={seeNote}
    currencyHandler={currencyHandler}
  />
)
}
PickupDetails.defaultProps = {
  onBack: () => { },
  seeNote: () => { },
  order_id: undefined
}

export default PickupDetails;